import { PortableBookPanel } from './PortableBookPanel.js';
import { TakeYourBook } from './TakeYourBook.js';

/**
 * WS11 — "My book" route (/my-book). The practitioner's identity-spanning sealed-book surface:
 *  • PortableBookPanel — display + search of their OWN sealed clients unioned across renter residencies,
 *    each tagged by salon (the server read-side union; ADR-0012 §2).
 *  • TakeYourBook      — the clean-exit, per-salon export (switch-in → export → switch-back).
 *
 * No RBAC gate: every authenticated practitioner has a "my book" keyed on their own session — a
 * practitioner with no sealed book simply sees the honest empty states. Mirrors MyWeekPage's layout.
 */
export function BookPage() {
  return (
    <>
      <div className="topbar">
        <div className="topbar__title">My book</div>
      </div>

      <div className="screen-scroll">
        <div
          className="screen-pad"
          style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 880 }}
        >
          <PortableBookPanel />
          <TakeYourBook />
        </div>
      </div>
    </>
  );
}
